import React, { useState, useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import AnimatedSection from '../components/AnimatedSection';
import { FaBriefcase, FaConciergeBell, FaBed, FaUtensils } from 'react-icons/fa';

// Data ini dapat dipindahkan ke Firestore untuk kontrol dinamis penuh
const careerProspects = [
    { icon: <FaConciergeBell />, title: 'Front Office Agent' },
    { icon: <FaBed />, title: 'Housekeeping Supervisor' },
    { icon: <FaUtensils />, title: 'Food & Beverage Staff' },
    { icon: <FaBriefcase />, title: 'Event Coordinator' },
];

const PerhotelanPage = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
        setLoading(true);
        try {
            // TODO: Ganti dengan fetch dari Firestore
            // const q = query(collection(db, "activities"), where("major", "==", "perhotelan"));
            // const querySnapshot = await getDocs(q);
            // const activitiesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            // setActivities(activitiesData);

            // Mensimulasikan pengambilan data dengan data statis
            const staticActivities = [
              { id: 1, title: 'Praktik Table Manner & Fine Dining', description: 'Siswa belajar etiket makan standar internasional dan seni melayani tamu di restoran fine dining, langsung di laboratorium praktik kami yang menyerupai restoran hotel.', image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=1974' },
              { id: 2, title: 'Kunjungan Industri ke Hotel Berbintang', description: 'Secara rutin, kami mengadakan kunjungan ke hotel-hotel partner untuk memberikan siswa wawasan langsung tentang operasional departemen Front Office, Housekeeping, dan F&B.', image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070' },
              { id: 3, title: 'Lomba Kompetensi Siswa (LKS)', description: 'Siswa kami aktif berpartisipasi dan sering meraih prestasi dalam LKS bidang perhotelan, mengasah kemampuan mereka dalam Reception, Room Service, dan Making Bed.', image: 'https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?q=80&w=2070' },
            ];
            setActivities(staticActivities);

        } catch (error) {
            console.error("Error fetching activities: ", error);
        } finally {
            setLoading(false);
        }
    };

    fetchActivities();
  }, []);

  return (
    <>
      <PageHeader 
        title="Jurusan Perhotelan" 
        subtitle="Mencetak Profesional Perhotelan yang Kompeten dan Siap Bersaing Global" 
      />
      <AnimatedSection>
        <section className="section">
          <div className="container">
            <h2>Galeri Kegiatan Perhotelan</h2>
            <p className="page-intro-text">
              Jurusan Perhotelan di SMK Pariwisata Sumbangsih berfokus pada pembelajaran praktik yang mendalam untuk mempersiapkan siswa menjadi profesional yang siap kerja. Berikut adalah beberapa aktivitas unggulan kami.
            </p>
            {loading ? (
              <p style={{textAlign: 'center'}}>Memuat kegiatan...</p>
            ) : (
              <div className="activity-grid">
                {activities.map((activity) => (
                  <div key={activity.id} className="activity-card">
                    <img src={activity.image} alt={activity.title} className="activity-image" />
                    <h3 className="activity-title">{activity.title}</h3>
                    <p className="activity-description">{activity.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </AnimatedSection>

      <AnimatedSection>
        <section className="section career-prospects-section">
            <div className="container">
                <h2>Prospek Karir Lulusan</h2>
                <p className="page-intro-text">
                    Lulusan jurusan Perhotelan memiliki peluang karir yang luas di industri pariwisata dan perhotelan, baik di dalam maupun luar negeri.
                </p>
                <div className="prospects-grid">
                    {careerProspects.map((prospect, index) => (
                        <div key={index} className="prospect-card">
                            <div className="prospect-icon">{prospect.icon}</div>
                            <h3>{prospect.title}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
      </AnimatedSection>

      {/*Mengapa memilih jurusan perhotelan*/}
      <AnimatedSection>
        <section className="section">
          <div className="container">
            <h2>Mengapa Memilih Jurusan Perhotelan?</h2>
            <div className="why-choose-us-grid">
              <div className="why-choose-us-item">
                <h3>Fasilitas Praktik Lengkap</h3>
                <p>Dilengkapi dengan laboratorium praktik Front Office, Housekeeping, dan Food & Beverage yang menyerupai standar hotel bintang.</p>
              </div>
              <div className="why-choose-us-item">
                <h3>Kurikulum Berbasis Kompetensi</h3>
                <p>Materi pembelajaran disesuaikan dengan standar kompetensi industri perhotelan, memastikan lulusan siap kerja dan bersaing.</p>
              </div>
              <div className="why-choose-us-item">
                <h3>Program Magang di Hotel Ternama</h3>
                <p>Kesempatan magang di hotel-hotel berbintang dan resort terkemuka untuk pengalaman kerja nyata.</p>
              </div>
              <div className="why-choose-us-item">
                <h3>Pengajar Profesional</h3>
                <p>Dibimbing oleh para praktisi dan akademisi berpengalaman di bidang perhotelan.</p>
              </div>
            </div>
          </div>
        </section>
      </AnimatedSection>
      
    </>
  );
};

export default PerhotelanPage;